import { Text } from "@bridgesplit/ui";
import { COPY } from "app/constants";
import { Divider } from "@mui/material";

import { VaultInfoSection } from "../common";
import VaultCapsTable from "./VaultCapsTable";
import CapStats from "./CapsStats";
import { useVaultContext } from "../../VaultContext";
import { useVaultCapsSummary } from "./util";

export default function VaultCaps() {
    const { vaultExpanded } = useVaultContext();
    const vaultCapsSummary = useVaultCapsSummary({ vaultExpanded });

    return (
        <VaultInfoSection header="Liquidity Management">
            <Text variant="body2" color="caption">
                The {COPY.VAULT_TERM.toLowerCase()} {COPY.VAULT_MANAGER_TERM.toLocaleLowerCase()} can update the supply
                limit, borrow limit, and withdrawl limits. All changes are applied immediately.
            </Text>
            <CapStats />
            <Divider />
            <Text variant="h4">Limits</Text>
            <VaultCapsTable vaultExpanded={vaultExpanded} vaultCapsSummary={vaultCapsSummary} />
        </VaultInfoSection>
    );
}
